const component = "site-tree-structure";

export const siteTreeStructure = {
  component,
  searchInput: `${component}/search-section-input`,
  noResultText: `${component}/no-result-text`,
};
